var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboard = function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.398 21.8A10.98 10.98 0 0 1 1 13C1 6.925 5.925 2 12 2s11 4.925 11 11c0 3.504-1.65 6.735-4.398 8.8l-.267.2H5.665zm12.26-1.8a9 9 0 1 0-11.315 0zm-.339-12.427-1.638-1.146-2.633 3.761a3 3 0 1 0 1.538 1.29zM13 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
    clipRule: "evenodd"
  })));
};
export default SvgDashboard;